import defaultAttributes from '../defaultAttributes';

const AlarmCheck = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16z' }],
    ['path', { d: 'M5 3 2 6' }],
    ['path', { d: 'm22 6-3-3' }],
    ['path', { d: 'm6 19-2 2' }],
    ['path', { d: 'm18 19 2 2' }],
    ['path', { d: 'm9 13 2 2 4-4' }],
  ],
];

export default AlarmCheck;
